/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verifyemail1Inputs */

const en_verifyemail1 = /** @type {(inputs: Verifyemail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify Email`)
};

const de_verifyemail1 = /** @type {(inputs: Verifyemail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse bestätigen`)
};

/**
* | output |
* | --- |
* | "Verify Email" |
*
* @param {Verifyemail1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const verifyemail1 = /** @type {((inputs?: Verifyemail1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verifyemail1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verifyemail1(inputs)
	return de_verifyemail1(inputs)
});
export { verifyemail1 as "verifyEmail" }